﻿import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from '../../_services';

import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
    selector: 'app-alert',
    templateUrl: 'alert.component.html'
})

export class AlertComponent implements OnInit, OnDestroy {
    private subscription: Subscription;
    message: any;

    @BlockUI() blockUI: NgBlockUI;

    isBlocked: Boolean = false;

    constructor(private alertService: AlertService) { }

    ngOnInit() {
        this.subscription = this.alertService.getMessage().subscribe(message => {
            this.message = message;
            if (this.message && this.message.block) {
                this.isBlocked = true;
                this.blockUI.start('Loading...');
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    close() {
        this.message = false;
        if (this.isBlocked) {
            this.isBlocked = false;
            this.blockUI.stop();
        }

    }

}
